/* eslint-disable camelcase */
import { Component, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class LinkedProducts extends ThemeComponent {

    @Prop tag!: string;
    @Prop selectedProductHandle!: string;
    @Prop apiToken!: string;

    async init() {
        try {
            // Console Log for testing purposes, leave eslint line in as well if you want to use log.
            // eslint-disable-next-line no-console
            // console.log('[Linked Products] init()', { tag: this.tag, selected: this.selectedProductHandle });
            await this.fetchLinkedProducts();
        } catch (error) {
            if (typeof error === "string") {
                throw Error(error);
            } else if (error instanceof Error) {
                throw Error(error.message);
            }
        }
    }

    async fetchLinkedProducts() {
        if (!this.tag) { return; }

        try {
            const isLocal = window.location.hostname === "127.0.0.1" || window.location.hostname === "localhost";
            const endpoint = isLocal
                ? "/api/unstable/graphql.json" // dev: proxy by Shopify CLI
                // : "/api/2023-04/graphql.json"; // old: stable API version from original code
                : "/api/2025-07/graphql.json"; // live: stable API version

            const headers = new Headers({
                /* eslint-disable */
                "Content-Type": "application/json",
                // only send token on live (local proxy doesn’t need it)
                ...(isLocal ? {} : { "X-Shopify-Storefront-Access-Token": this.apiToken })
                /* eslint-enable */
            });

            // eslint-disable-next-line no-console
            console.log("[LinkedProducts] Fetching linked products", { endpoint, tag: this.tag });

            const linkedProducts = fetch(endpoint,
                {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({
                        query: `
                                query GroupedProducts($query: String!) {
                                    products(first: 20, query: $query) {
                                        edges {
                                            node {
                                                id,
                                                title,
                                                onlineStoreUrl,
                                                handle,
                                                featuredImage {
                                                    url
                                                }
                                            }
                                        }
                                    }
                                }
                            `,
                        variables: {
                            query: `tag:"${this.tag.replace(/"/g, '\\"')}" AND available_for_sale:1`
                        }
                    })
                }
            ).then(((res) => res.json()))
                .then((products) => products.data.products.edges)
                .catch((error) => {
                    if (typeof error === "string") {
                        throw Error(error);
                    } else if (error instanceof Error) {
                        throw Error(error.message);
                    }
                });

            await linkedProducts.then((products: LinkedProductData) => {
                const html = products.map((p) => this.renderProduct(p)).join('');
                this.innerHTML = html;
            });


        } catch (error) {
            if (typeof error === "string") {
                throw Error(error);
            } else if (error instanceof Error) {
                throw Error(error.message);
            }
        }
    }

    renderProduct(product: LinkedProduct) {
        const isActive = product.node.handle === this.selectedProductHandle ? 'linked-products__product-selected' : '';
        const img = product.node.featuredImage?.url
            ? `<img class="linked-products__image" src="${product.node.featuredImage.url}" alt="">`
            : `<span class="linked-products__image linked-products__image--placeholder" aria-hidden="true"></span>`;

        return `
    <div class="linked-products__product ${isActive}">
      <a class="linked-products__link" href="/products/${product.node.handle}">
        ${img}
      </a>
    </div>
  `;
    }
}
